import { useState, useEffect, useRef } from 'react';

export default function useError() {
    const [error, setError] = useState(null);

    const timeoutRef = useRef();

    useEffect(() => {
        timeoutRef.current && clearTimeout(timeoutRef.current);
        if (error) {
            timeoutRef.current = setTimeout(() => setError(null), 3000);
        }
    }, [error]);

    return { error, setError };
}
